<template>
  <div style="display: flex; flex-direction: column">
    <div style="margin-bottom: 5px;">
      <el-button
        :disabled="disabled"
        type="primary"
        @click="getCargoInformation"
      >
        {{ $t('SeaExport.GetGoodsInformation') }}
      </el-button>
      <el-tooltip
        effect="light"
        :content="$t('SeaExport.GetGoodsInformationTip')"
        placement="right-end"
        disabled
      >
        <i style="cursor:pointer;margin-left:4px;color:#1989fa;" class="el-icon-question" />
      </el-tooltip>
    </div>
    <el-input
      v-model="job.measurements"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { warehouseInList } from '@/api/seaExport/warehouseIn'

export default {
  name: 'AeBasicMeasurements',
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    getCargoInformation() {
      if (!this.job.uuid) return
      warehouseInList(this.job.uuid).then(res => {
        const result = res.data
        if (result && result.length > 0) {
          const map = new Map()
          for (const item of result) {
            const dimension = item.dimension
            if (!dimension) continue // 判断尺寸是否为空
            const arr = dimension.split('*')
            if (!arr || arr.length !== 4) continue // 长*宽*高*件数，非这个格式则不处理
            const key = arr[0] + '*' + arr[1] + '*' + arr[2]
            const quantity = Number(map.get(key) || 0) + Number(arr[3])
            map.set(key, quantity)
          }
          if (map) {
            const sizeArr = []
            map.forEach(function(value, key) {
              sizeArr.push((key + '*' + value))
            })
            const size = sizeArr.join('\n')
            if (size) {
              this.job.measurements = size
              this.$emit('change', this.job.measurements)
            }
          }
        }
      })
    }
  }
}
</script>
